import Components from './../Component';

export default class Tooltip extends Components {

  constructor($) {
    super($);
  }

  init(index, element) {

    var side = 'top';
    if (this.$(element).attr('data-tooltip-side')) {
      side = this.$(element).attr('data-tooltip-side');
    }

    document.addEventListener('keydown', function(e) {
      if (e.keyCode ==27){
        this.$(element).tooltipster('hide');
      }

    }.bind(this));


    this.$(element).tooltipster({
      content: this.$(element).attr('data-tooltip'),
      theme: 'tooltipster-shadow',
      'laa.follower': {
        anchor: 'top-center'
      },
      animation: 'fade',
      delay: [100, 150],
      trigger: 'custom',
      triggerOpen: {
        mouseenter: true,
        click:true
      },
      triggerClose: {
        mouseleave: true,
        click:true
      },
      contentAsHTML: true,
      interactive: true,
      side: side
    });
  }
}